var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 33499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 15 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93436 2.7873C8.16596 2.18168 7.05887 2.18168 6.29046 2.7873L2.56445 5.72396C2.24311 5.97722 2.05686 6.35535 2.05686 6.75448V11.5495C2.05686 12.2859 2.67868 12.8828 3.44575 12.8828H11.7791C12.5461 12.8828 13.168 12.2859 13.168 11.5495V6.75448C13.168 6.35535 12.9817 5.97722 12.6604 5.72396L8.93436 2.7873ZM5.40916 1.75678C6.68984 0.747415 8.53499 0.747416 9.81566 1.75678L13.5417 4.69343C14.1844 5.19995 14.5569 5.95623 14.5569 6.75448V11.5495C14.5569 13.0223 13.3132 14.2162 11.7791 14.2162H3.44575C1.91162 14.2162 0.667969 13.0223 0.667969 11.5495V6.75448C0.667969 5.95622 1.04047 5.19995 1.68315 4.69343L5.40916 1.75678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 55",
    d: "M15.334 8.00024V6.66691H12.6673V8.00024H15.334ZM12.6673 8.00024C12.6673 8.68586 12.6838 9.2331 12.6932 9.65672C12.7029 10.0978 12.7034 10.3705 12.6848 10.5856C12.659 10.8832 12.6109 11.0701 12.2629 11.5395L14.4051 13.1276C14.9793 12.3531 15.2645 11.7067 15.3415 10.8152C15.3743 10.4358 15.3686 10.0252 15.3592 9.59807C15.3494 9.15356 15.334 8.64796 15.334 8.00024H12.6673ZM12.2629 11.5395C12.1511 11.6903 11.8957 11.8877 10.9889 11.9725C10.0613 12.0594 8.93691 12.0002 7.33398 12.0002V14.6669C8.73105 14.6669 10.1456 14.7298 11.2374 14.6276C12.35 14.5235 13.5946 14.2209 14.4051 13.1276L12.2629 11.5395Z",
    fill: "url(#paint0_linear_2816_75057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 56",
    d: "M6.33398 13.5498H9.00065",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 56_2",
    d: "M13.1561 8.00024C13.1561 8.39298 13.4745 8.71136 13.8672 8.71136C14.2599 8.71136 14.5783 8.39298 14.5783 8.00024H13.1561ZM14.5783 8.00024V6.66691H13.1561V8.00024H14.5783Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7778 10.6668C12.0107 10.6668 11.3889 11.2638 11.3889 12.0002C11.3889 12.7365 12.0107 13.3335 12.7778 13.3335C13.5448 13.3335 14.1667 12.7365 14.1667 12.0002C14.1667 11.2638 13.5448 10.6668 12.7778 10.6668ZM10 12.0002C10 10.5274 11.2437 9.3335 12.7778 9.3335C14.3119 9.3335 15.5556 10.5274 15.5556 12.0002C15.5556 13.4729 14.3119 14.6668 12.7778 14.6668C11.2437 14.6668 10 13.4729 10 12.0002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60476 4C8.04439 4 8.40078 4.34593 8.40078 4.77265V7.86326C8.40078 8.28998 8.04439 8.63591 7.60476 8.63591C7.16513 8.63591 6.80874 8.28998 6.80874 7.86326V4.77265C6.80874 4.34593 7.16513 4 7.60476 4ZM6.80078 10.1773C6.80078 9.75062 7.15717 9.4047 7.5968 9.4047H7.60476C8.04439 9.4047 8.40078 9.75062 8.40078 10.1773C8.40078 10.6041 8.04439 10.95 7.60476 10.95H7.5968C7.15717 10.95 6.80078 10.6041 6.80078 10.1773Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2816_75057",
    x1: 6.83155,
    y1: 7.73261,
    x2: 27.1667,
    y2: 13.4531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF974A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5A5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenCancel);
export default __webpack_public_path__ + "static/media/token_cancel.8a8f2d806ad7783e5c4479f83c88a927.svg";
export { ForwardRef as ReactComponent };